
import styled, { createGlobalStyle } from 'styled-components';

export const DatePickerGlobalStyles = createGlobalStyle`
  .react-datepicker {
    font-family: inherit;
    border: none;
    width: 100%;
  }

  .react-datepicker__month-container {
    width: 100%;
    float: none;
  }

  .react-datepicker__header {
    background-color: var(--white);
    border-bottom: 1px solid #e8eaf0;
    padding: 12px 0 8px;
  }

  .react-datepicker__current-month {
    font-size: 15px;
    font-weight: 600;
    color: #1a2b4a;
    text-transform: capitalize;
    margin-bottom: 8px;
  }

  .react-datepicker__navigation {
    top: 14px;
  }

  .react-datepicker__navigation-icon::before {
    border-color: #1a6fc4;
    border-width: 2px 2px 0 0;
    width: 7px;
    height: 7px;
  }

  .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
    border-color: #0d4f9e;
  }

  .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
    padding: 0 4px;
    margin-bottom: 0;
  }

  .react-datepicker__day-name {
    font-size: 12px;
    font-weight: 500;
    color: #6b7a99;
    width: 36px;
    line-height: 28px;
    text-align: center;
    text-transform: capitalize;
  }

  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
    padding: 0 4px;
  }

  .react-datepicker__month {
    margin: 6px 0;
  }

  .react-datepicker__day {
    width: 36px;
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    color: #1a2b4a;
    border-radius: 50%;
    margin: 1px 0;

    &:hover {
      background-color: #e8f0fb;
      color: #1a6fc4;
      border-radius: 50%;
    }
  }

  .react-datepicker__day--today {
    font-weight: 600;
    color: #1a6fc4;
    background-color: transparent;
    border: 1.5px solid #1a6fc4;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--range-end {
    background-color: #1a6fc4 !important;
    color: #fff !important;
    border-radius: 50% !important;
    font-weight: 500;
    border: none !important;
  }

  .react-datepicker__day--in-range {
    background-color: #dceafb;
    color: #1a6fc4;
    border-radius: 0;
  }

  .react-datepicker__day--range-start {
    background-color: #1a6fc4 !important;
    color: #fff !important;
    border-radius: 50% 0 0 50% !important;
  }

  .react-datepicker__day--range-end {
    border-radius: 0 50% 50% 0 !important;
  }

  .react-datepicker__day--range-start.react-datepicker__day--range-end {
    border-radius: 50% !important;
  }

  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: #dceafb;
    color: #1a6fc4;
  }

  .react-datepicker__day--disabled {
    color: #c8cdd8;

    &:hover {
      background-color: transparent;
      color: #c8cdd8;
    }
  }

  .react-datepicker__day--outside-month {
    color: #b0b8cc;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const TriggerButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 16px;
  border-radius: 4px;
  border: none;
  background-color: #ECE2FC;
  color: #0066B3;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  height: 32px;
  box-sizing: border-box;
  font-family: sans-serif;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;

  &:hover {
    background-color: #e0d6f5;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const ChevronIcon = styled.span<{ $open?: boolean }>`
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const Popover = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1000;
  width: 296px;
  background: var(--white);
  border: 1px solid #dde3ef;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(26, 43, 74, 0.12);
  overflow: hidden;
`;

export const PopoverHeader = styled.div`
  padding: 16px 16px 12px;
  border-bottom: 1px solid #eef0f6;
`;

export const PopoverTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #0066B3;
  font-family: 'Caixa Std', sans-serif;
`;

export const DateInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CalendarIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: currentColor;
`;

export const CalendarWrapper = styled.div`
  padding: 4px 12px 0;

  .react-datepicker__navigation--previous {
    left: 16px;
  }

  .react-datepicker__navigation--next {
    right: 16px;
  }
`;

export const PopoverFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #eef0f6;
`;

export const ClearButton = styled.button`
  padding: 7px 16px;
  border: none;
  background: transparent;
  color: #1a6fc4;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s;

  &:hover {
    background: #f0f5fc;
  }
`;

export const ApplyButton = styled.button`
  padding: 7px 20px;
  border: none;
  background: #1a6fc4;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s;

  &:hover {
    background: #155aa0;
  }

  &:disabled {
    background: #a0b8d8;
    cursor: not-allowed;
  }
`;

export const DateInput = styled.input<{ $isInvalid?: boolean }>`
  flex: 1;
  padding: 7px 10px;
  border: 1px solid ${({ $isInvalid }) => ($isInvalid ? '#d64545' : '#dde3ef')};
  border-radius: 6px;
  font-size: 13px;
  color: #1a2b4a;
  background: #f8f9fc;
  outline: none;
  box-sizing: border-box;
  min-width: 0;
  cursor: text;

  &:focus {
    border-color: ${({ $isInvalid }) => ($isInvalid ? '#d64545' : '#1a6fc4')};
    background: #fff;
  }
`;

export const DateInputSeparator = styled.span`
  color: #6b7a99;
  font-size: 14px;
  flex-shrink: 0;
  padding: 0 4px;
`;
